import { ResourcesService } from '@mitsubishi/core';
import { ProjectStatisticsCounts } from '@mitsubishi/project/data-access';

export const INACTIVE_ICON_COLOR = 'var(--apm-light-gray2)';

const STATUS_RESOURCE_IDS = {
  offerDraft: 448753,
  offerFinal: 448755,
  orderError: 448758,
  orderDraft: 448757,
  orderPending: 465159,
  orderFinal: 448761,
} as const;

const OFFER_TOOLTIP_FALLBACK_RESOURCE_ID = 444924;
const ORDER_TOOLTIP_FALLBACK_RESOURCE_ID = 444925;

function buildTooltip(
  states: { count: number; resourceId: number }[],
  fallbackResourceId: number,
  resourcesService: ResourcesService
): string {
  const tooltip = states
    .filter(state => state.count > 0)
    .map(state => `${state.count} ${resourcesService.getTextResource(state.resourceId)}`)
    .join('\n');

  return tooltip || resourcesService.getTextResource(fallbackResourceId);
}

export function getQuoteColor(counts: ProjectStatisticsCounts): string {
  return counts.quoteDraftCount > 0 ? 'var(--apm-selection-quote)' : INACTIVE_ICON_COLOR;
}

export function getOfferColor(counts: ProjectStatisticsCounts): string {
  return counts.offerDraftCount + counts.offerFinalCount > 0 ? 'var(--apm-selection-offer)' : INACTIVE_ICON_COLOR;
}

export function getOrderColor(counts: ProjectStatisticsCounts): string {
  if (counts.orderErrorCount > 0) return 'var(--apm-selection-error)';
  if (counts.orderDraftCount > 0) return 'var(--apm-selection-order-draft)';
  if (counts.orderPendingCount > 0) return 'var(--apm-selection-order-sending)';
  if (counts.orderFinalCount > 0) return 'var(--apm-selection-order)';

  return INACTIVE_ICON_COLOR;
}

export function getEnergyAnalysisColor(count: number): string {
  return count > 0 ? 'var(--apm-energy-analysis)' : INACTIVE_ICON_COLOR;
}

export function getOfferTooltip(counts: ProjectStatisticsCounts, resourcesService: ResourcesService): string {
  const states = [
    { count: counts.offerDraftCount, resourceId: STATUS_RESOURCE_IDS.offerDraft },
    { count: counts.offerFinalCount, resourceId: STATUS_RESOURCE_IDS.offerFinal },
  ];

  return buildTooltip(states, OFFER_TOOLTIP_FALLBACK_RESOURCE_ID, resourcesService);
}

export function getOrderTooltip(counts: ProjectStatisticsCounts, resourcesService: ResourcesService): string {
  const states = [
    { count: counts.orderErrorCount, resourceId: STATUS_RESOURCE_IDS.orderError },
    { count: counts.orderDraftCount, resourceId: STATUS_RESOURCE_IDS.orderDraft },
    { count: counts.orderPendingCount, resourceId: STATUS_RESOURCE_IDS.orderPending },
    { count: counts.orderFinalCount, resourceId: STATUS_RESOURCE_IDS.orderFinal },
  ];

  return buildTooltip(states, ORDER_TOOLTIP_FALLBACK_RESOURCE_ID, resourcesService);
}
